import style from 'styled-components';

export const StyledPageTitle = style.section`
  @media only screen and (max-width: ${props => props.theme.screens.md}){
    h1 {
        display: none;
    }
  }
`;
